import styled from "styled-components";

export const FormStyled = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  padding: 2rem;
  border-radius: 1rem;

  background-color: var(--bg-form);
  color: var(--white);
`